// extracted by mini-css-extract-plugin
module.exports = {"app":"page_app__BK_A5","btn-wrap":"page_btn-wrap__AhtKN","image-wrap":"page_image-wrap__9NDun"};